import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgHome = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeWidth={2}
      d="M5 22h1.525a2 2 0 0 0 2-2v-1.362a2 2 0 0 1 2-2h1.95a2 2 0 0 1 2 2V20a2 2 0 0 0 2 2H18a2 2 0 0 0 2-2v-9.265a2 2 0 0 0-.55-1.378l-6.5-6.833a2 2 0 0 0-2.9 0l-6.5 6.833A2 2 0 0 0 3 10.735V20a2 2 0 0 0 2 2Z"
    />
  </svg>
);
export default SvgHome;
